import { render, staticRenderFns } from "./ProcessSort.vue?vue&type=template&id=591e6abc&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./ProcessSort.vue?vue&type=script&lang=js&"
export * from "./ProcessSort.vue?vue&type=script&lang=js&"
import style0 from "./ProcessSort.vue?vue&type=style&index=0&id=591e6abc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591e6abc",
  null
  
)

export default component.exports